import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import {
  Box,
  Button,
  Backdrop,
  CircularProgress,
  Autocomplete,
  TextField,
  Paper,
  FormControlLabel,
  Switch,
  Select,
  MenuItem,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Tabs,
  Tab,
} from "@mui/material";

import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import ERPGrid from "../components/ERPGrid";
import { util } from "../util/index";
import { ColDef } from "ag-grid-community";
import ERPSnakBar from "../components/ERPSnakBar";
import useLocalStorage from "../hooks/useLocalStorage";
import {
  getShipDataByClient,
 changeShipmentStatus,
  updateDeliveredStatus,
  updateShipDataByShipNo
} from "../services/shipDataService";
import { getClientForSelection } from "../services/clientService";
import download from "downloadjs";
import { ExportToExcel } from "../util/globals";
import { get, set } from "lodash";
import UpdateRemarks from "../components/UpdateRemarks";
import DateValue from "../components/DateValue";
import { Label } from "@mui/icons-material";


function ShippingList() {
  const [list, setList] = useState<any[]>([]);
  const [data,setData]=useState([])
  const [loading, setLoading] = useState(false);
  const [blNo,setBlNo]=useState("")
  const [shipNo,setShipNo]=useState("") 
  const [blDate,setBlDate]=useState(dayjs(new Date()))
  const [showEdit,setShowEdit]=useState(false)  
  const [fromDate, setFromDate] = useState(
    dayjs(new Date()).subtract(2, "month")
  );
  const [alert, setAlert] = useState({
    open: false,
    message: "",
    serverity: "",
  });
  const [toDate, setToDate] = useState(dayjs(new Date()));
  const gridRef = useRef<any>(null);
  const { user_type, client_id } = useLocalStorage();
  const [pinnedRows, setPinnedRows] = useState<any[]>([]);
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState<any>(null);
  const [editShipNo,setEditShipNo]=useState("")
  const [editShipDate,setEditShipDate] = useState<Dayjs | null>(null)
  const [editBlNo,setEditBlNo]=useState("")
  const [editBlDate,setEditBlDate]=useState<Dayjs | null>(null)
  const [editClose,setEditClose]=useState<boolean>(false)
  const [closeOpen,setCloseOpen]=useState<string>("false")
  const [tab, setTab] = useState(0);
  const [confirmDialog, setConfirmDialog] = useState<{
    open: boolean;
    ship_no: string;
    newStatus: boolean;
    field: "close" | "delivered";
  }>({ open: false, ship_no: "", newStatus: false, field: "close" });

  const closeColDef: ColDef = {
    filter: true,
    field: "is_close",
    headerName: "Close",
    width: 80,
    cellRenderer: (params: any) => {
      if (params.node.rowPinned) return null;
      return (
        <Checkbox
          size="small"
          checked={!!params.data.is_close}
          onChange={() =>
            setConfirmDialog({
              open: true,
              ship_no: params.data.ship_no,
              newStatus: !params.data.is_close,
              field: "close",
            })
          }
        />
      );
    },
  };

  const deliveredColDef: ColDef = {
    filter: true,
    field: "delivered",
    headerName: "Delivered",
    width: 90,
    cellRenderer: (params: any) => {
      if (params.node.rowPinned) return null;
      return (
        <Checkbox
          size="small"
          checked={!!params.data.delivered}
          onChange={() =>
            setConfirmDialog({
              open: true,
              ship_no: params.data.ship_no,
              newStatus: !params.data.delivered,
              field: "delivered",
            })
          }
        />
      );
    },
  };

  const detailColDefs: ColDef[] = [
   {
      filter: true,
      field: "ship_no",
      headerName: "Shipping No",
      width: 150,
      cellClass:"shipping_no",
      onCellClicked: (params: any) => handleStartEdit(params),
    },
    {
      filter: true,
      field: "ship_date",
      headerName: "Shipping Date",
      cellClass: "common-cell-format",
      width: 110,
      cellRenderer: (params: any) => <DateValue value={params.value} />
    },
    {
      filter: true,
      field: "vendor",
      headerName: "Vendor",
      width: 120,
    },
    {
      field: "client_order_no",
      headerName: "PO No",
      sortable: true,
      filter: true,
      width: 100,
    },
    {
      field: "brand",
      headerName: "Brand",
      sortable: true,
      filter: true,
      width: 110,
    },
    {
      field: "art_name",
      headerName: "Article",
      sortable: true,
      filter: true,
      width: 150,
    },
    {
      field: "color",
      headerName: "Color",
      width: 130,
      filter: true,
      sortable: true,
    },
    {
      field: "size",
      headerName: "Size",
      width: 100,
      filter: true,
      sortable: true,
    },
    {
      field: "qty",
      headerName: "Qty",
      width: 90,
      filter: true,
      sortable: true,
    },
    {
      field: "price",
      headerName: "Price",
      width: 90,
      filter: true,
      sortable: true,
    },
    {
      field: "amount",
      headerName: "Amount",
      width: 110,
      filter: true,
      sortable: true,
    },
    {
      filter: true,
      field: "ship_type",
      headerName: "Shipping Type",
      width: 110,
    },
    
    {
      filter: true,
      field: "approved_ship_date",
      cellClass: "common-cell-format",
      headerName: "Approved ShipDate",
     cellRenderer: (params: any) => <DateValue value={params.value} />,
     width: 110
    },
    {
      filter: true,
      field:"bl_no",
      headerName:"BL No",
      width:80,
     
    },
     {
      filter: true,
      field: "bl_date",
      headerName: "BL Date",
      minWidth: 100,
      width: 110,
      cellRenderer: (params: any) => <DateValue value={params.value} />
    },
    {
      
      field: "remarks",
      headerName: "Remarks",
      minWidth: 250,
      cellRenderer :(params:any)=> params.data.size!="Total" && <UpdateRemarks key={params.data.id} id={params.data.id} value={params.data.remarks} getUpdateList={getShippingList} />,
      flex: 1,
      suppressKeyboardEvent: (params) => {
      const e = params.event as KeyboardEvent;
      const keys = [
        "ArrowLeft","ArrowRight","ArrowUp","ArrowDown",
        "Home","End","Backspace","Delete"
      ];
      // suppress grid handling if our input is focused or we're “editing” in the renderer
      const target = e.target as HTMLElement | null;
      const isInput =
        !!target && (target.tagName === "INPUT" || target.tagName === "TEXTAREA");
      return (isInput || params.editing) && keys.includes(e.key);
    },
    },
  ];

  const masterColDefs: ColDef[] = [
    closeColDef,
    deliveredColDef,
    {
      filter: true,
      field: "ship_no",
      headerName: "Shipping No",
      width: 150,
    },
    {
      filter: true,
      field: "ship_date",
      headerName: "Shipping Date",
      cellClass: "common-cell-format",
      width: 110,
      cellRenderer: (params: any) => <DateValue value={params.value} />,
    },
    {
      filter: true,
      field: "vendor",
      headerName: "Vendor",
      width: 150,
    },
    {
      field: "client_order_no",
      headerName: "PO No",
      sortable: true,
      filter: true,
      width: 110,
    },
    {
      field: "brand",
      headerName: "Brand",
      sortable: true,
      filter: true,
      width: 120,
    },
    {
      filter: true,
      field: "ship_type",
      headerName: "Shipping Type",
      width: 120,
    },
    {
      filter: true,
      field: "approved_ship_date",
      cellClass: "common-cell-format",
      headerName: "Approved ShipDate",
      cellRenderer: (params: any) => <DateValue value={params.value} />,
      width: 130,
    },
    {
      filter: true,
      field: "bl_no",
      headerName: "BL No",
      width: 100,
    },
    {
      filter: true,
      field: "bl_date",
      headerName: "BL Date",
      minWidth: 100,
      width: 110,
      cellRenderer: (params: any) => <DateValue value={params.value} />,
    },
    {
      field: "qty",
      headerName: "Qty",
      width: 100,
      filter: true,
      sortable: true,
    },
    {
      field: "amount",
      headerName: "Amount",
      width: 120,
      filter: true,
      sortable: true,
      flex: 1,
    },
  ];

  const masterRows = useMemo(() => {
    const map = new Map<string, any>();
    list.forEach((row: any) => {
      if (!map.has(row.ship_no)) {
        map.set(row.ship_no, {
          ship_no: row.ship_no,
          ship_date: row.ship_date,
          vendor: row.vendor,
          client_order_no: row.client_order_no,
          brand: row.brand,
          ship_type: row.ship_type,
          approved_ship_date: row.approved_ship_date,
          bl_no: row.bl_no,
          bl_date: row.bl_date,
          is_close: row.is_close,
          delivered: row.delivered,
          qty: 0,
          amount: 0,
        });
      }
      const master = map.get(row.ship_no);
      master.qty += Number(row.qty) || 0;
      master.amount += Number(row.amount) || 0;
    });
    return Array.from(map.values());
  }, [list]);

  const getShippingList = async () => {
    if (user_type === "Admin" && !selectedClient) {
      setAlert({
        open: true,
        message: "Please select a client",
        serverity: "error",
      });
      return;
    }
    setLoading(true);
    try {
      const response =
        user_type === "Admin"
          ? await getShipDataByClient(
              selectedClient?.id,
              dayjs(fromDate).format("YYYY-MM-DD"),
              dayjs(toDate).format("YYYY-MM-DD"),
              closeOpen==="true"? true : false
            )
          : await getShipDataByClient(
              client_id,
              dayjs(fromDate).format("YYYY-MM-DD"),
              dayjs(toDate).format("YYYY-MM-DD"),
              closeOpen==="true"? true : false
            );
      setList(response.data);
      setData(response.data);
      getTotalRowCount(response.data);
    } catch (error) {
      console.log(error);
      setAlert({
        open: true,
        message: "Error fetching data",
        serverity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const getTotalRowCount = useCallback(
    (data: any[]) => {
      setPinnedRows([]);
      const totalRow = {
        size: "Total",
        qty: data.reduce((acc, item) => acc + Number(item.qty), 0),
        amount: data.reduce((acc, item) => acc + Number(item.amount), 0),
        
      };
      setPinnedRows([totalRow]);
    },
    [pinnedRows]
  );

  const onFilterChanged = useCallback(() => {
    if (!gridRef.current) return;
    const visibleRows: any[] = [];
    gridRef.current.forEachNodeAfterFilterAndSort((node: any) => {
      if (!node.group) {
        visibleRows.push(node.data);
      }
    });
    getTotalRowCount(visibleRows);
  }, [getTotalRowCount]);

  const onGridReady = (params: any) => {
    gridRef.current = params.api;
  };

  useEffect(() => {
    getTotalRowCount(tab === 0 ? masterRows : list);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab, masterRows, list]);

  useEffect(() => {
    const getClients = async () => {
      try {
        const response: any = await getClientForSelection();
        setClients(response.data);
      } catch (error) {
        console.log(error);
      }
    };
    getClients();
  }, []);

  const handleExportToExcel = () => {
    const blob = ExportToExcel(tab === 0 ? masterRows : list, "Shipping List", [
      "id",
      "client_id",
      "client",
      "vendor_id",
    ]);
    download(
      blob,
      "wip_report.xlsx",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    );
  };

  const handleStatusConfirm = async () => {
    try {
      setLoading(true);
      const response: any =
        confirmDialog.field === "close"
          ? await changeShipmentStatus(confirmDialog.ship_no, confirmDialog.newStatus)
          : await updateDeliveredStatus(confirmDialog.ship_no, confirmDialog.newStatus);
      if (response.status) {
        if (confirmDialog.field === "close") {
          const newList: any[] = (list as any[]).filter((row: any) => row.ship_no !== confirmDialog.ship_no);
          setList(newList);
          getTotalRowCount(newList);
        } else {
          const newList: any[] = (list as any[]).map((row: any) =>
            row.ship_no === confirmDialog.ship_no ? { ...row, delivered: confirmDialog.newStatus } : row
          );
          setList(newList);
        }
      }
    } catch (error) {
      setAlert({ open: true, message: "Error updating shipment status", serverity: "error" });
    } finally {
      setLoading(false);
      setConfirmDialog({ open: false, ship_no: "", newStatus: false, field: "close" });
    }
  };

  const handleStartEdit = (params: any) => {
    setShowEdit(true);
    setShipNo(params.data.ship_no);
    setEditShipNo(params.data.ship_no);
    setEditShipDate(params.data.ship_date ? dayjs(params.data.ship_date) : null);
    setEditBlNo(params.data.bl_no || "");
    setEditBlDate(params.data.bl_date ? dayjs(params.data.bl_date) : null);
    setEditClose(params.data.is_close || false);
  }

  return (
    <>
      <Box
        sx={{
          mt: 1,
          p: 2,
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "flex-start",
          gap: 1,
          border: 1,
          borderColor: "divider",
          width: {
            xs: "93vw",
            lg: `calc(95vw - ${util.sidebarWidth}px)`,
          },
          borderRadius: "4px",
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            sx={{ width: { xs: "100%", sm: 150 } }}
            label="From Date"
            format="DD-MM-YYYY"
            value={fromDate}
            onChange={(newValue) => {
              setFromDate(dayjs(newValue));
            }}
            slotProps={{ textField: { size: "small" } }}
          />
          <DatePicker
          sx={{ width: { xs: "100%", sm: 150 } }}
            label="To Date"
            format="DD-MM-YYYY"
            value={toDate}
            onChange={(newValue) => {
              setToDate(dayjs(newValue));
            }}
            slotProps={{ textField: { size: "small" } }}
          />
          <Autocomplete
          size="small"
            sx={{
              width: { xs: "100%", sm: 200 },
              display: user_type === "Admin" ? "block" : "none",
            }}
            options={clients}
            getOptionLabel={(option: any) => option.name}
            renderInput={(params) => <TextField {...params} label="Client"   />}
            value={selectedClient}
            onChange={(_, newValue) => {
              setSelectedClient(newValue);
            }}
          />
          <Select
            size="small"
            sx={{
              width: { xs: "100%", sm: 100 },
            }}
            value={closeOpen}
            onChange={(e)=>setCloseOpen(e.target.value as string)}
          >
           <MenuItem value={"false"}>Open</MenuItem>
            <MenuItem value={"true"}>Closed</MenuItem>
            
          </Select>
        </LocalizationProvider>
        <Button variant="outlined" color="primary" onClick={getShippingList} size="small">
          Refresh
        </Button>
        <Button
          size="small"
          variant="outlined"
          color="success"
          onClick={handleExportToExcel}
          sx={{ display: list?.length > 0 ? "block" : "none" }}
        >
          To Excel
        </Button>
      </Box>

      <Tabs value={tab} onChange={(_, newValue) => setTab(newValue)} sx={{ mt: 1 }}>
        <Tab label="Master" />
        <Tab label="Detail" />
      </Tabs>

      <Box
        sx={{
          width: {
            // xs: `calc(100vw - ${util.erpGridMarginX}px)`,
            // lg: `calc(100vw - ${util.sidebarWidth}px - ${util.erpGridMarginX}px)`,
          },

          mt: 2,
          "& .shipping_no:hover": {
            textDecoration: "underline",
            color: (theme) => theme.palette.primary.main,
          },
          "& .ag-cell": {
            whiteSpace: "normal !important",
            lineHeight: "1.2 !important",
            fontSize: "0.7rem !important",
             paddingY: "4px",
             paddingX: "6px",
          },
          
          "& .ag-header-cell": {
           whiteSpace: "normal !important",
            lineHeight: "1.4 !important",
           paddingX: "6px",
            textAlign: "center",
            fontSize: "0.75rem !important",
          },
          "& .common-cell-format": {
            textAlign: "center",
          },
        }}
      >
        <ERPGrid
          key={tab}
          ref={gridRef}
          gridHeight={"70vh"}
          columnDefs={tab === 0 ? masterColDefs : detailColDefs}
          rowData={tab === 0 ? masterRows : list}
          heading={tab === 0 ? "Shipping List - Master" : "Shipping List - Detail"}
          pinnedBottomRowData={pinnedRows}
          onGridReady={onGridReady}
          onFilterChanged={onFilterChanged}
          rowHeight={35}  
          getRowStyle={(params: any) => {
            if (params.node?.rowPinned) {
              return { fontWeight: "bold", backgroundColor: "var(--ag-header-background-color)" };
            } else if (
              params.data?.account_title?.toString().includes("Total")
            ) {
              return { fontWeight: "bold", backgroundColor: "var(--ag-header-background-color)" };
            }
            return null;
          }}
        />
      </Box>
      <Dialog open={confirmDialog.open} onClose={() => setConfirmDialog({ open: false, ship_no: "", newStatus: false, field: "close" })}>
        <DialogTitle sx={{ textAlign: "center" }}>{confirmDialog.ship_no}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {confirmDialog.field === "close" ? (
              <>Sure to update status to <strong>{confirmDialog.newStatus ? "Closed" : "Open"}</strong>?</>
            ) : (
              <>Sure to mark as <strong>{confirmDialog.newStatus ? "Delivered" : "Not Delivered"}</strong>?</>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="error" onClick={() => setConfirmDialog({ open: false, ship_no: "", newStatus: false, field: "close" })}>
            Cancel
          </Button>
          <Button variant="contained" color="success" onClick={handleStatusConfirm}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <ERPSnakBar
        open={alert.open}
        message={alert.message}
        serverity={alert.serverity}
        onClose={() => setAlert({ open: false, message: "", serverity: "" })}
      />
      <Backdrop
        sx={{ color: "common.white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Backdrop open={showEdit} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Paper sx={{ p: 2 ,minWidth: 350,borderRadius: 2 }} elevation={3}>
         
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box mt={2} display="flex" justifyContent="flex-end" gap={1} flexDirection={"column"}>
              <TextField label="Shipping No" variant="outlined" fullWidth size="small" 
            slotProps={{inputLabel:{shrink:true}}}
            value= {shipNo} disabled/>

            <TextField label="Shipping No (Edit)" variant="outlined" fullWidth size="small" 
            slotProps={{inputLabel:{shrink:true}}}
            value= {editShipNo} onChange={(e:any)=>setEditShipNo(e.target.value)}
            disabled={editClose}
            />
          <DatePicker label="Shipping Date" slotProps={{textField:{size:"small"}}} format="DD-MM-YYYY"  
          value={editShipDate} onChange={(newValue)=>setEditShipDate(dayjs(newValue))}
           disabled={editClose}
          />
          <TextField label="BL No" variant="outlined" fullWidth size="small" 
           slotProps={{inputLabel:{shrink:true}}}
          value={editBlNo} onChange={(e:any)=>setEditBlNo(e.target.value)}
           disabled={editClose}
          />
         <DatePicker label="BL Date" slotProps={{textField:{size:"small",onKeyDown:(e:any)=> {if(e.key=="Delete" || e.key=="Backspace") { setEditBlDate(dayjs(null)); } }}}} format="DD-MM-YYYY"  
         value={editBlDate} onChange={(newValue)=>setEditBlDate(dayjs(newValue))}
          disabled={editClose}
         />
         
         
          <Button variant="contained" color="primary"
           onClick={async() => {
             const response =await updateShipDataByShipNo(
              shipNo,
               editShipNo || "",
               editShipDate ? editShipDate.format("YYYY-MM-DD") :  null,
               editBlNo || "",
               editBlDate ? editBlDate.format("YYYY-MM-DD") : null
                ,editClose
             );
              if (response.status) {
                setShowEdit(false);
                getShippingList();
              }
           }}
          >
            Save
          </Button>
          <Button variant="outlined" color="secondary" onClick={() => setShowEdit(false)}>
            Cancel
          </Button>
         </Box>
          </LocalizationProvider>
        </Paper>
      </Backdrop>
    </>
  );


  

}




export default ShippingList;
